import React from 'react';
import { useIntl } from 'react-intl';
import { FormProvider } from 'react-hook-form';
import { computeText } from '@/locales/utils';
import Wizard from '@/components/atoms/Wizard';
import RawModal from '@/components/atoms/RawModal';
import { useCreatePickupPointModalVM } from './CreatePickupPointModal.viewmodel';
import { Container } from './CreatePickupPointModal.style';

type CreatePickupPointModalProps = {
    onHide: () => void;
    brandId: number;
    restaurantId?: number;
    pickupPointId: number;
    name: string;
    address: string;
    additionalAddressInfo: string | null;
    isOpen: boolean;
};

export const CreatePickupPointModal: React.FunctionComponent<React.PropsWithChildren<CreatePickupPointModalProps>> = ({
    onHide,
    brandId,
    restaurantId,
    pickupPointId,
    name,
    address,
    additionalAddressInfo,
    isOpen,
}) => {
    const intl = useIntl();
    const { form, currentStep, steps, errorMessage, isLoading, handleHide, onFormValidate } =
        useCreatePickupPointModalVM({
            onHide,
            brandId,
            restaurantId,
            pickupPointId,
            name,
            address,
            additionalAddressInfo: additionalAddressInfo || '',
        });

    return (
        <RawModal isOpen={isOpen} onHide={handleHide}>
            <FormProvider {...form}>
                <Container>
                    <Wizard
                        width={600}
                        selectedStep={currentStep}
                        steps={steps}
                        validateLabel={computeText(intl, 'button.save')}
                        onValidate={onFormValidate}
                        errorMessage={errorMessage}
                        isLoading={isLoading}
                    />
                </Container>
            </FormProvider>
        </RawModal>
    );
};
